module.exports = __webpack_public_path__ + "img/q_img03.9826e15a.jpg";